export const DOMAIN = "https://dragon.n11s.io";

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/winazdangcapthuongluu",
  telegram: "https://telegram.me/winazdangcapthuongluu",
};

export const generateRandomString = (length: number) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }

  return result;
};
